import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ContextService } from '@lr/core';

/**
 * HR Portal guard: ensures user has at least one group (client) assigned.
 * Runs after contextReadyCanActivate. Redirects to /no-group-access if user has no groups.
 */
export const hasGroupCanActivate: CanActivateFn = () => {
  const contextService = inject(ContextService);
  const router = inject(Router);

  if (contextService.isSessionRejected) {
    router.navigate(['/unauthorized'], { replaceUrl: true });
    return false;
  }

  // Stale cache / failed load: not the same as "authenticated with zero groups".
  if (contextService.getPermissions() == null) {
    return false;
  }

  const clients = contextService.getClients();
  if (clients.length > 0) {
    return true;
  }

  router.navigate(['/no-group-access'], { replaceUrl: true });
  return false;
};
